export default __webpack_public_path__ + "static/media/trr-food-pastry-9.faa6357a.png";